export const handleGetAgingDate = (date) => {
  if (!date) return 0;
  const dateFrom = new Date(date);
  const dateTo = new Date();
  if (isNaN(dateFrom)) return 0;
  const ms1 = dateFrom.getTime();
  const ms2 = dateTo.getTime();
  const diff = ms2 - ms1;
  return Math.ceil(diff / (1000 * 60 * 60 * 24)); // days
};

export const handleReturnAgingColor = (date, termDay) => {
  const days = handleGetAgingDate(date)
  const finalDate = Math.ceil(days / termDay)
  if (finalDate <= 1) {
    return '#00C8511A'
  } else if (finalDate > 1 && finalDate <= 2) {
    return '#438AFE1A'
  } else if (finalDate > 2 && finalDate <= 3) {
    return '#FFA3301A'
  } else {
    return '#D725251A'
  }
}